<template>
  <div class="d-flex justify-start align-start gap my-2 cart_course_item">
    <div><v-icon icon="mdi-flag-variant" color="primary" size="small"></v-icon></div>
    <div>
      <div class="text-subtitle-2"><span v-if="!mainStore.parcours_billetterie_mode">Parcours</span><span
          v-else>Forfait</span></div>
      <div class="text-body-2">{{ item.nom }}</div>
    </div>
    <div class="justify-self-end text-body font-weight-bold">
      <span v-if="item.current_price">{{ item.current_price }}€</span><span v-else>Gratuit</span>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: ["item"],
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Cart.scss";
</style>